export enum InvoiceStatusEnum {
  Created = 1,
  AwaitingPayment,
  PartiallyPaid,
  Fulfilled,
  Canceled,
  Deactivated,
}
